<script>

    import ChatSetupController from "./controller";
    import WidgetTemplate from './widget/index';

    export default {

        mixins: [ ChatSetupController ],

        components: { WidgetTemplate }
    }
</script>

<template>
    <div class="">

        <el-button
            type="primary"
            plain
            size="small"
            @click="drawer = true">
            Get started
            <i class="el-icon-right"/>
        </el-button>

        <el-drawer
            title="Set up web chat"
            :visible.sync="drawer"
            :with-header="false"
            size="80%">
            <div class="drawer-area">
                <div class="drawer-body">
                    <div class="webchat-setup">
                        <div class="">
                            <div class="">
                                <div class="col-md-7 bordered-div" v-if="step === 'webchat'">
                                    <div class="row section-header">
                                        <p>Step 1/3 - Website Details</p>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 form-group">
                                            <label for="" >Site Name</label>
                                            <el-input v-model="form.name" placeholder="i.e Emalify Application"/>
                                        </div>
                                        <div class="col-md-12 form-group">
                                            <label for="" >Host Name</label>
                                            <el-input v-model="form.hostname" placeholder="i.e emalify.com"/>
                                        </div>
                                        <div class="col-md-12 form-group">
                                            <label for="" >Customer Account</label>
                                            <el-input v-model="form.customer_account" type="number" placeholder="i.e 12345"
                                            />
                                        </div>
                                        <div class="col-md-12 form-group">
                                            <el-checkbox v-model="form.show_agent_profile">Show support agent's profile</el-checkbox>
                                        </div>
                                        <div class="col-md-12 form-group">
                                            <el-color-picker v-model="form.color"/>
                                            <label for="" >Pick a color calibration</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-7 bordered-div" v-if="step === 'upload'">
                                    <div class="row section-header">
                                        <p>Step 2/3 - Upload your logo</p>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <input type="file" @change="onUpload" accept="image/*" placeholder="Image">
                                            <br>
                                            <span v-if="uploading">
                                                <i class="el-icon-loading loading-icon" /> Uploading
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-7 bordered-div" v-if="step === 'snipet'">
                                    <div class="row section-header">
                                        <p>Step 3/3 - Get the widget</p>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <pre class="pretty-print">
      &lt;<span class="pl-ent">emalify-chat-widget<span></span></span>&gt;&lt;/<span class="pl-ent">emalify-chat-widget</span>&gt;
      &lt;<span class="pl-ent">script</span>  <span class="pl-e">src</span>=<span class="pl-s"><span class="pl-pds">"</span>https://emalify-chat-dot-chatleo-111.appspot.com/js/app.js<span class="pl-pds">"</span></span>&gt;&lt;/<span class="pl-ent">script</span>&gt;
                      </pre>
                                            <br>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-5">
                                    <widget-template
                                        :application="application"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="" v-if="step === 'webchat'">
                        <el-button type="primary" size="small" @click="submitWebChat">Submit <i class="el-icon-loading" v-if="sending"/></el-button>
                        <el-button plain size="small" @click="next('upload')">Next <i class="el-icon-right"/></el-button>
                    </div>
                    <div class="" v-if="step === 'upload'">
<!--                        <el-button type="primary" size="small" @click="submitAgent">Submit <i class="el-icon-loading" v-if="sending"/> </el-button>-->
                        <el-button type="" plain size="small" @click="next('webchat')"><i class="el-icon-back"/> Back </el-button>
                        <el-button type="" plain size="small" @click="next('snipet')">Next <i class="el-icon-right"/></el-button>
                    </div>
                    <div class="" v-if="step === 'snipet'">
                        <el-button type="" plain size="small" @click="back('upload')"><i class="el-icon-back"/> Back</el-button>
                        <el-button type="primary" size="small" @click="subscribe">
                            Finish
                            <i class="el-icon-loading" v-if="subscribing"/>
                            <span v-else>👍</span>
                        </el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<style lang="scss" scoped>

    /*.webchat-setup {*/
    /*    width: 100%;*/
    /*    display: flex;*/
    /*    background-color: #fff;*/
    /*    &__right {*/
    /*        width: 100%;*/
    /*    }*/
    /*}*/

    .pretty-print {
        font-size: 14px;
        font-family: Roboto;
        background-color: #e3e6f054;
        border-radius: 2px;
        color: #7f838c;
        padding: 20px 10px 0 10px;
    }
    .drawer-actions {

    }

    .bordered-div {
        padding: 20px;
        border-radius: 5px;
        margin-top: 30px;
    }

    .section-header {
        padding-left: 10px;
        font-weight: bold;
        font-size: 14px;
        color: black;
    }
</style>
